'use strict';

export function createLinkRowManager(container) {
  const tpl = document.getElementById('link-row-tpl')
           || document.getElementById('update-edit-link-row-tpl');

  function makeRow()  { return tpl.content.cloneNode(true).firstElementChild; }
  function rows()     { return [...container.querySelectorAll('.proj-update-link-row')]; }
  function isEmpty(r) {
    const [l, u] = r.querySelectorAll('input');
    return l.value.trim() === '' && u.value.trim() === '';
  }

  function ensureTrailingEmpty() {
    const all = rows();
    if (!all.length || !isEmpty(all[all.length - 1])) { attach(container.appendChild(makeRow())); }
  }

  function attach(row) {
    row.querySelectorAll('input').forEach(inp => {
      inp.addEventListener('input', ensureTrailingEmpty);
      inp.addEventListener('blur', () => {
        const all = rows();
        if (isEmpty(row) && all[all.length - 1] !== row) row.remove();
      });
    });
  }

  rows().forEach(attach);
  ensureTrailingEmpty();
}
